import { render, staticRenderFns } from "./FormDadosCadastrais.vue?vue&type=template&id=60e51898&"
import script from "./FormDadosCadastrais.vue?vue&type=script&lang=js&"
export * from "./FormDadosCadastrais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports